module.exports = __webpack_public_path__ + "img/intel.ed45f256.png";